
export default class NullCheckUtil {
  static isNullOrUndefined(value: unknown): boolean {
    return value === null || value === undefined
  }
}
